import { gql } from '@apollo/client'

export default gql`
	query AutocompleteEventName($part: String!) {
		autocompleteName(part: $part)
	}
`
